import React from 'react'
import { Card, Typography, Switch, Space, Badge } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import ServiceItem from './ServiceItem'

const ServiceCategory = ({
  category,
  services,
  onServiceToggle,
  onCategoryToggle,
  isExpanded,
  activeServices,
  style = {},
  handleToggleAllCategoryServices
}) => {
  const { Title, Text } = Typography

  return (
    <Card
      size='small'
      style={{
        marginBottom: '16px',
        borderRadius: '8px',
        overflow: 'hidden',
        ...style
      }}
      bodyStyle={{ padding: 0 }}
    >
      {/* Category Header */}
      <div
        style={{
          background: `linear-gradient(135deg, ${category.color}15, ${category.color}08)`, // TODO: we need to add category colours
          borderBottom: '1px solid #f0f0f0',
          padding: '16px',
          cursor: 'pointer',
          transition: 'background-color 0.2s'
        }}
        onClick={() => {
          onCategoryToggle(category.value)
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
            {/* Category Icon and Name */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ fontSize: '20px' }}>{category.icon}</span> {/*TODO: EMOTICON HERE*/}
              <Title
                level={5}
                style={{
                  margin: 0,
                  color: category.color, // TODO: COLOR HERE
                  fontSize: '16px',
                  fontWeight: '600'
                }}
              >
                {category.label}
              </Title>
            </div>

            {/* Service Count Badge */}
            <Badge
              count={0} // NEED TO CHECK ACTIVE COUNT
              style={{
                backgroundColor: 0 > 0 ? '' : '#d9d9d9', // TODO: COLOR HERE
                color: '#fff',
                fontSize: '11px'
              }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {/* Category Toggle All Switch */}
            <Space>
              <Text style={{ fontSize: '12px', color: '#666' }}>All:</Text>
              <Switch
                size='small'
                checked={services.every((s) => activeServices.includes(s._id))}
                indeterminate={
                  services.some((s) => activeServices.includes(s._id)) &&
                  !services.every((s) => activeServices.includes(s._id))
                }
                onChange={(boolean) => {
                  handleToggleAllCategoryServices(boolean, category.value)
                }}
              />
            </Space>

            {/* Expand/Collapse Icon */}
            <FontAwesomeIcon
              icon={isExpanded ? faChevronDown : faChevronRight}
              style={{
                color: category.color, // TODO: COLOR HERE
                fontSize: '12px',
                transition: 'transform 0.2s'
              }}
              onClick={() => {
                onCategoryToggle(category.value)
              }}
            />
          </div>
        </div>

        {/* Category Description */}
        <Text
          style={{
            fontSize: '12px',
            color: '#666666',
            marginTop: '4px',
            display: 'block'
          }}
        >
          {category.description}
        </Text>
      </div>

      {/* Services List */}
      {isExpanded && (
        <div>
          {services.map((service) => (
            <ServiceItem
              key={service._id}
              service={service}
              isActive={activeServices.includes(service._id)} // TODO: NEED TO CHECK ACTIVE SERVICES
              onToggle={onServiceToggle}
            />
          ))}
        </div>
      )}
    </Card>
  )
}

export default ServiceCategory
